import { DragSource } from 'react-dnd'
import React from 'react'

export class Contactor extends React.Component {
    constructor(props) {
        super(props)

        var opacity = this.props.isDragging ? 0.4 : 1

        this.state = {
            isDragging: opacity
        }
    }

    handleDeletingContactor (itemID) {
        this.props.handleDeletingContactor(itemID)
    }

    handleContactorAutoAdd (itemID) {
        this.props.handleContactorAutoAdd(itemID, this.props.quantity)
    }

    render() {
        const opacity = this.props.isDragging ? 0.4 : 1

        return (
        <div className={ 'breaker' + (this.props.isDisabled ? ' is-disabled' : '')} ref={ this.props.connectDragSource } style={{ opacity }}>
            <span className="breaker__number">{ this.props.usedCount }</span>
            <span className={ 'breaker__type breaker__type--' + this.props.poleCount }>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
                <span className="pole-ui"></span>
            </span>
            <span className="breaker__title">
                Contactor: { this.props.description }

                {
                    this.props.isDisabled &&
                    <div className="breaker__subtitle">Cannot be fitted on to this board</div>
                }
            </span>
            <div className="breaker__actions">
                <button className="button--icon" onClick={ () => { this.handleDeletingContactor(this.props.ItemID) } }>
                    <span className="button__icon">
                        <span className="i-trash-bin"></span>
                    </span>
                </button>

                {!this.props.isDragAndDropEnabled && !this.props.isDisabled &&
                    <div className='breaker__quantity'>
                        <input className="input" type="number" value={ this.props.quantity } onChange={(e) => this.props.handleContactorUpdateQuantity(e.target.value, this.props.ItemID)}  />
                    </div>
                }

                { !this.props.isDisabled && 
                    <button className="button button--outline button-auto-placement" disabled={this.props.quantity < 1} onClick={ () => { this.handleContactorAutoAdd(this.props.ItemID) } }>
                        <span className="button__icon">
                            <span className="i-plus"></span>
                        </span>
                    </button>
                }
            </div>
        </div>
        )
    }
}

export default DragSource('ResidentialChassisPole', 
    {
        beginDrag: (props) => {
            return { 
                ItemID: props.ItemID,
                ContactorItemID: props.ContactorItemID,
                poleCount: props.poleCount
            }
        },
        endDrag(props, monitor) {
            const item = monitor.getItem()
            const dropResult = monitor.getDropResult() 

            if (dropResult !== null && (props.isAllowedToDragNDropPole === true || props.isAllowedToDragNDropPole === undefined)) {
                props.addContactorToBoard(dropResult.rowIndex, dropResult.poleIndex, item.ItemID, item.ContactorItemID)
            }
        },
        canDrag(props) {
            return props.isDragAndDropEnabled
        }
    }, 
    (connect, monitor) => {
        return {
            connectDragSource: connect.dragSource(),
            isDragging: monitor.isDragging()
        }
    }
)(Contactor)
